import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Select } from 'antd';
import FormItem from "components/fields/FormItem";
import { 
	getRegions
} from "../../redux/psgcdata/psgcDataState";
import PSGCAPIService from '../../services/psgcapiservice';

function AddressFilter({ form, filters, getRegionList, regions, ...props }) {

	const {className} = props;
	const [provinces, setProvinces] = useState([]);
	const [municipalities, setMunicipalities] = useState([]);
	const [barangays, setBarangays] = useState([]);

	const [hideProvince, setHideProvince] = useState(false);
		
	const handleRegionChange = (value) => {
		form.setFieldsValue({
			...form.getFieldsValue(), 
			province_code: null, 
			municipality_code: null, 
			barangay_code: null
		});
		value && doGetRegionCityProvince(value);				
	};

	const doGetRegionCityProvince = (code) => {		
		if(code === '130000000'){
			setHideProvince(true);
			getNCRCityList(code);					
		}else{
			setHideProvince(false);
			getProvinceList(code);
		}	
	}

	const handleProvinceChange = (value) => {
		form.setFieldsValue({
			...form.getFieldsValue(), 
			municipality_code: null, 
			barangay_code: null
		});
		getMunicipalityList(value);
	}

	const handleMunicipalityChange = (value) =>{
		form.setFieldsValue({
			...form.getFieldsValue(), 
			barangay_code: null
		});
		getBarangayList(value);
	}

	useEffect(() => {
		getRegionList({});

		if(filters){
			if(filters?.region_code){
				doGetRegionCityProvince(filters?.region_code);							
			}
			if(filters?.province_code){
				getMunicipalityList(filters?.province_code);
			}
			if(filters?.municipality_code){
				getBarangayList(filters?.municipality_code);
			}
		}

	}, [filters]);

	const psgcAPIPath = 'https://psgc.gitlab.io/api/';
	const getPSGCData = async (endpoint, callback) => {
		try {
			const provinceList = await PSGCAPIService.doRequest(
				`${psgcAPIPath}${endpoint}`, 
				"GET"
			);
			// Convert list to { label, value } format for antd Select
			const options = provinceList.map(region => ({
				label: region.name,
				value: region.code
			}));
			callback && callback(options);
		} catch (err) {
			console.error("Failed to fetch PSGC data", err);
		}
	}

	const getNCRCityList = async (regionCode) => {
		setProvinces([]);
		getPSGCData(`regions/${regionCode}/cities.json`, setMunicipalities);
	};

	const getProvinceList = async (regionCode) => {
		setProvinces([]);
		getPSGCData(`regions/${regionCode}/provinces.json`, setProvinces);
	};

	const getMunicipalityList = async (provinceCode) => {
		setMunicipalities([]);
		getPSGCData(`provinces/${provinceCode}/cities-municipalities.json`, setMunicipalities);
	};

	const getBarangayList = async (municipalityCode) => {
		setBarangays([]);
		getPSGCData(`cities-municipalities/${municipalityCode}/barangays.json`, setBarangays);
	};
	
  return (
		<div className={className ?? "form-column-4"}>
			<FormItem 
				name="region_code"
				label="Region"
			>
				<Select id="region_code"            		
					options={regions}
					showSearch
					allowClear={true}
					onChange={handleRegionChange}
				/>					
			</FormItem>
			<FormItem hidden={hideProvince}
				name="province_code"
				label="Province"			
			>
				<Select id="province_code"            		
					options={provinces}
					showSearch
					allowClear={true}
					onChange={handleProvinceChange}
				/>					
			</FormItem>
			<FormItem 
				name="municipality_code"
				label="Municipality/City"
			>
				<Select id="municipality_code"            		
					options={municipalities}
					showSearch
					allowClear={true}
					onChange={handleMunicipalityChange}
				/>
			</FormItem>	
			<FormItem 
				name="barangay_code"
				label="Barangay"
			>
				<Select id="barangay_code"            		
					options={barangays}
					showSearch
					allowClear={true}
				/>
			</FormItem>            
		</div>
  );
}

const mapStateToProps = (state) => ({
	regions: state.psgcData.regions?.items,
});

const mapDispatchToProps = (dispatch) => ({
	getRegionList: (data) => dispatch(getRegions(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddressFilter);
